import styled from "styled-components";

export const Breadcrumbs = styled.div`
  display: flex;
  gap: 0 15px;
  padding: 48px 0;
  font-size: 17px;
  line-height: 24px;
  color: #A1ABC9;
  
  & a {
    color: #7297FF;
    text-decoration: none;
  }

`
